import { jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
var PlSinglePageLayout = function (_a) {
    var header = _a.header, children = _a.children;
    return (_jsxs("div", { className: "w-full mx-auto max-w-screen-lg", children: [header, children] }));
};
export default PlSinglePageLayout;
